import React, { useCallback } from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim"; 

const ParticlesBackground = () => {
    const particlesInit = useCallback(async engine => {
        await loadSlim(engine);
    }, []);

    const particlesOptions = {
        particles: {
            number: {
                value: 85,
                density: {
                    enable: true,
                    value_area: 900
                }
            },
            color: {
                value: ["#6c63ff", "#00c3ff", "#8a2be2", "#00e5ff"]
            },
            shape: {
                type: "circle"
            },
            opacity: {
                value: 0.6,
                random: true,
                anim: {
                    enable: true,
                    speed: 0.5,
                    opacity_min: 0.3,
                    sync: false
                }
            },
            size: {
                value: 5,
                random: true,
                anim: {
                    enable: true,
                    speed: 3,
                    size_min: 2,
                    sync: false
                }
            },
            line_linked: {
                enable: true,
                distance: 130,
                color: "#03ff4a",
                opacity: 0.3,
                width: 1
            },
            move: {
                enable: true,
                speed: 1.0,
                direction: "none",
                random: false,
                straight: false,
                out_mode: "out",
                attract: {
                    enable: false
                }
            }
        },
        interactivity: {
            detect_on: "canvas",
            events: {
                onhover: {
                    enable: true,
                    mode: "grab"
                },
                onclick: {
                    enable: true,
                    mode: "push"
                },
                resize: true
            },
            modes: {
                grab: {
                    distance: 160,
                    line_linked: {
                        opacity: 0.5
                    }
                },
                push: {
                    particles_nb: 4
                }
            }
        },
        // --- LÍNEA CORREGIDA ---
        // Se elimina la comilla extra de "retina_detect"
        retina_detect: true
    };

    return (
        <Particles
            id="tsparticles"
            init={particlesInit}
            options={particlesOptions}
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: 0
            }}
        />
    );
};

export default ParticlesBackground;